/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlChangePasswordRequest
 */
export interface ControlChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlChangePasswordRequest
     */
    old_password: string;
    /**
     * 
     * @type {string}
     * @memberof ControlChangePasswordRequest
     */
    new_password: string;
}

/**
 * Check if a given object implements the ControlChangePasswordRequest interface.
 */
export function instanceOfControlChangePasswordRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "old_password" in value;
    isInstance = isInstance && "new_password" in value;

    return isInstance;
}

export function ControlChangePasswordRequestFromJSON(json: any): ControlChangePasswordRequest {
    return ControlChangePasswordRequestFromJSONTyped(json, false);
}

export function ControlChangePasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlChangePasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'old_password': json['old_password'],
        'new_password': json['new_password'],
    };
}

export function ControlChangePasswordRequestToJSON(value?: ControlChangePasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'old_password': value.old_password,
        'new_password': value.new_password,
    };
}

